import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';


import enCommon from './locales/en/common.json';
import arCommon from './locales/ar/common.json';

import enHome from './locales/en/home.json';
import arHome from './locales/ar/home.json';

import enAuth from './locales/en/auth.json';
import arAuth from './locales/ar/auth.json';


import enProducts from './locales/en/products.json';
import arProducts from './locales/ar/products.json';


import enCart from './locales/en/cart.json';
import arCart from './locales/ar/cart.json';

import enAccounts from './locales/en/accounts.json';
import arAccounts from './locales/ar/accounts.json';

import policies_en from './locales/en/policies.json';
import policies_ar from './locales/ar/policies.json';

import components_en from './locales/en/components.json';
import components_ar from './locales/ar/components.json';


i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // Arabic is the site's default language. `navigator`/`htmlTag` are left
        // out of the detection order on purpose: with them the browser locale
        // (or the Django-rendered <html lang>) would decide for a first-time
        // visitor and English browsers would never see the Arabic default.
        // Only an explicit choice — query string, or a previously stored one —
        // overrides it.
        fallbackLng: 'ar',
        supportedLngs: ["en", "ar"],
        detection: {
            order: ['querystring', 'cookie', 'localStorage'],
            // `django_language` is Django's LANGUAGE_COOKIE_NAME, so caching the
            // choice here also tells the server which language to render the
            // index.html shell in (<html lang>/dir, title, meta description).
            lookupCookie: 'django_language',
            cookieMinutes: 60 * 24 * 365,
            caches: ['localStorage', 'cookie'],
        },
        resources: {
            en: {
                common: enCommon,
                home: enHome,
                auth: enAuth,
                products: enProducts,
                cart: enCart,
                accounts: enAccounts,
                policies: policies_en,
                components: components_en
            },
            ar: {
                common: arCommon,
                home: arHome,
                auth: arAuth,
                products: arProducts,
                cart: arCart,
                accounts: arAccounts,
                policies: policies_ar,
                components: components_ar
            }
        },
        ns: ['common', 'home', 'auth',
            'products', 'cart', 'accounts',
            "policies", "components"],
        defaultNS: "common",
        // debug: process.env.NODE_ENV === "development",

    });


export default i18n;